const fe = "2.23.9";
let I = {
  getDocsUrl: ({ docsBaseUrl: e, docsPath: t = "", docsSlug: r }) => t ? `${e ?? "https://viem.sh"}${t}${r ? `#${r}` : ""}` : void 0,
  version: `viem@${fe}`
};
class h extends Error {
  constructor(t, r = {}) {
    const n = r.cause instanceof h ? r.cause.details : r.cause?.message ? r.cause.message : r.details, s = r.cause instanceof h && r.cause.docsPath || r.docsPath, i = I.getDocsUrl?.({ ...r, docsPath: s }), o = [
      t || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...i ? [`Docs: ${i}`] : [],
      ...n ? [`Details: ${n}`] : [],
      ...I.version ? [`Version: ${I.version}`] : []
    ].join(`
`);
    super(o, r.cause ? { cause: r.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = n, this.docsPath = s, this.metaMessages = r.metaMessages, this.name = r.name ?? this.name, this.shortMessage = t, this.version = fe;
  }
  walk(t) {
    return he(this, t);
  }
}
function he(e, t) {
  return t?.(e) ? e : e && typeof e == "object" && "cause" in e && e.cause !== void 0 ? he(e.cause, t) : t ? null : e;
}
class Se extends h {
  constructor({ max: t, min: r, signed: n, size: s, value: i }) {
    super(`Number "${i}" is not in safe ${s ? `${s * 8}-bit ${n ? "signed" : "unsigned"} ` : ""}integer range ${t ? `(${r} to ${t})` : `(above ${r})`}`, { name: "IntegerOutOfRangeError" });
  }
}
class St extends h {
  constructor(t) {
    super(`Bytes value "${t}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
      name: "InvalidBytesBooleanError"
    });
  }
}
class je extends h {
  constructor(t) {
    super(`Hex value "${t}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, { name: "InvalidHexBooleanError" });
  }
}
class Me extends h {
  constructor({ givenSize: t, maxSize: r }) {
    super(`Size cannot exceed ${r} bytes. Given size: ${t} bytes.`, { name: "SizeOverflowError" });
  }
}
class jt extends h {
  constructor({ offset: t, position: r, size: n }) {
    super(`Slice ${r === "start" ? "starting" : "ending"} at offset "${t}" is out-of-bounds (size: ${n}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
}
class be extends h {
  constructor({ size: t, targetSize: r, type: n }) {
    super(`${n.charAt(0).toUpperCase()}${n.slice(1).toLowerCase()} size (${t}) exceeds padding size (${r}).`, { name: "SizeExceedsPaddingSizeError" });
  }
}
class Mt extends h {
  constructor({ size: t, targetSize: r, type: n }) {
    super(`${n.charAt(0).toUpperCase()}${n.slice(1).toLowerCase()} is expected to be ${r} ${n} long, but is ${t} ${n} long.`, { name: "InvalidBytesLengthError" });
  }
}
function v(e, { dir: t, size: r = 32 } = {}) {
  return typeof e == "string" ? Re(e, { dir: t, size: r }) : Ce(e, { dir: t, size: r });
}
function Re(e, { dir: t, size: r = 32 } = {}) {
  if (r === null)
    return e;
  const n = e.replace("0x", "");
  if (n.length > r * 2)
    throw new be({
      size: Math.ceil(n.length / 2),
      targetSize: r,
      type: "hex"
    });
  return `0x${n[t === "right" ? "padEnd" : "padStart"](r * 2, "0")}`;
}
function Ce(e, { dir: t, size: r = 32 } = {}) {
  if (r === null)
    return e;
  if (e.length > r)
    throw new be({
      size: e.length,
      targetSize: r,
      type: "bytes"
    });
  const n = new Uint8Array(r);
  for (let s = 0; s < r; s++) {
    const i = t === "right";
    n[i ? s : r - s - 1] = e[i ? s : e.length - s - 1];
  }
  return n;
}
function L(e, { strict: t = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : t ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function se(e) {
  return L(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function S(e, { dir: t = "left" } = {}) {
  let r = typeof e == "string" ? e.replace("0x", "") : e, n = 0;
  for (let s = 0; s < r.length - 1 && r[t === "left" ? s : r.length - s - 1].toString() === "0"; s++)
    n++;
  return r = t === "left" ? r.slice(n) : r.slice(0, r.length - n), typeof e == "string" ? (r.length === 1 && t === "right" && (r = `${r}0`), `0x${r.length % 2 === 1 ? `0${r}` : r}`) : r;
}
const Ie = /* @__PURE__ */ new TextEncoder();
function Be(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? Te(e, t) : typeof e == "boolean" ? ze(e, t) : L(e) ? R(e, t) : pe(e, t);
}
function ze(e, t = {}) {
  const r = new Uint8Array(1);
  return r[0] = Number(e), typeof t.size == "number" ? (y(r, { size: t.size }), v(r, { size: t.size })) : r;
}
const p = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function oe(e) {
  if (e >= p.zero && e <= p.nine)
    return e - p.zero;
  if (e >= p.A && e <= p.F)
    return e - (p.A - 10);
  if (e >= p.a && e <= p.f)
    return e - (p.a - 10);
}
function R(e, t = {}) {
  let r = e;
  t.size && (y(r, { size: t.size }), r = v(r, { dir: "right", size: t.size }));
  let n = r.slice(2);
  n.length % 2 && (n = `0${n}`);
  const s = n.length / 2, i = new Uint8Array(s);
  for (let o = 0, u = 0; o < s; o++) {
    const l = oe(n.charCodeAt(u++)), c = oe(n.charCodeAt(u++));
    if (l === void 0 || c === void 0)
      throw new h(`Invalid byte sequence ("${n[u - 2]}${n[u - 1]}" in "${n}").`);
    i[o] = l * 16 + c;
  }
  return i;
}
function Te(e, t) {
  const r = ye(e, t);
  return R(r);
}
function pe(e, t = {}) {
  const r = Ie.encode(e);
  return typeof t.size == "number" ? (y(r, { size: t.size }), v(r, { dir: "right", size: t.size })) : r;
}
function y(e, { size: t }) {
  if (se(e) > t)
    throw new Me({
      givenSize: se(e),
      maxSize: t
    });
}
function Rt(e, t) {
  const r = { to: t }, n = r.to;
  return n === "number" ? Ue(e, r) : n === "bigint" ? ge(e, r) : n === "string" ? Le(e, r) : n === "boolean" ? ke(e, r) : R(e, r);
}
function ge(e, t = {}) {
  const { signed: r } = t;
  t.size && y(e, { size: t.size });
  const n = BigInt(e);
  if (!r)
    return n;
  const s = (e.length - 2) / 2, i = (1n << BigInt(s) * 8n - 1n) - 1n;
  return n <= i ? n : n - BigInt(`0x${"f".padStart(s * 2, "f")}`) - 1n;
}
function ke(e, t = {}) {
  let r = e;
  if (t.size && (y(r, { size: t.size }), r = S(r)), S(r) === "0x00")
    return !1;
  if (S(r) === "0x01")
    return !0;
  throw new je(r);
}
function Ue(e, t = {}) {
  return Number(ge(e, t));
}
function Le(e, t = {}) {
  let r = R(e);
  return t.size && (y(r, { size: t.size }), r = S(r, { dir: "right" })), new TextDecoder().decode(r);
}
const Ne = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function He(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? ye(e, t) : typeof e == "string" ? De(e, t) : typeof e == "boolean" ? qe(e, t) : me(e, t);
}
function qe(e, t = {}) {
  const r = `0x${Number(e)}`;
  return typeof t.size == "number" ? (y(r, { size: t.size }), v(r, { size: t.size })) : r;
}
function me(e, t = {}) {
  let r = "";
  for (let s = 0; s < e.length; s++)
    r += Ne[e[s]];
  const n = `0x${r}`;
  return typeof t.size == "number" ? (y(n, { size: t.size }), v(n, { dir: "right", size: t.size })) : n;
}
function ye(e, t = {}) {
  const { signed: r, size: n } = t, s = BigInt(e);
  let i;
  n ? r ? i = (1n << BigInt(n) * 8n - 1n) - 1n : i = 2n ** (BigInt(n) * 8n) - 1n : typeof e == "number" && (i = BigInt(Number.MAX_SAFE_INTEGER));
  const o = typeof i == "bigint" && r ? -i - 1n : 0;
  if (i && s > i || s < o) {
    const l = typeof e == "bigint" ? "n" : "";
    throw new Se({
      max: i ? `${i}${l}` : void 0,
      min: `${o}${l}`,
      signed: r,
      size: n,
      value: `${e}${l}`
    });
  }
  const u = `0x${(r && s < 0 ? (1n << BigInt(n * 8)) + BigInt(s) : s).toString(16)}`;
  return n ? v(u, { size: n }) : u;
}
const Fe = /* @__PURE__ */ new TextEncoder();
function De(e, t = {}) {
  const r = Fe.encode(e);
  return me(r, t);
}
class Ve extends h {
  constructor({ address: t }) {
    super(`Address "${t}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
}
class we extends Map {
  constructor(t) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = t;
  }
  get(t) {
    const r = super.get(t);
    return super.has(t) && r !== void 0 && (this.delete(t), super.set(t, r)), r;
  }
  set(t, r) {
    if (super.set(t, r), this.maxSize && this.size > this.maxSize) {
      const n = this.keys().next().value;
      n && this.delete(n);
    }
    return this;
  }
}
function j(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error("positive integer expected, got " + e);
}
function _e(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function P(e, ...t) {
  if (!_e(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function Ct(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  j(e.outputLen), j(e.blockLen);
}
function ie(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function We(e, t) {
  P(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error("digestInto() expects output buffer of length at least " + r);
}
const A = /* @__PURE__ */ BigInt(2 ** 32 - 1), ce = /* @__PURE__ */ BigInt(32);
function Je(e, t = !1) {
  return t ? { h: Number(e & A), l: Number(e >> ce & A) } : { h: Number(e >> ce & A) | 0, l: Number(e & A) | 0 };
}
function Xe(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let s = 0; s < e.length; s++) {
    const { h: i, l: o } = Je(e[s], t);
    [r[s], n[s]] = [i, o];
  }
  return [r, n];
}
const Ge = (e, t, r) => e << r | t >>> 32 - r, Ke = (e, t, r) => t << r | e >>> 32 - r, Qe = (e, t, r) => t << r - 32 | e >>> 64 - r, Ye = (e, t, r) => e << r - 32 | t >>> 64 - r, x = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Ze(e) {
  return new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4));
}
function It(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function Bt(e, t) {
  return e << 32 - t | e >>> t;
}
const ae = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function et(e) {
  return e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
}
function ue(e) {
  for (let t = 0; t < e.length; t++)
    e[t] = et(e[t]);
}
const tt = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function zt(e) {
  P(e);
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += tt[e[r]];
  return t;
}
function rt(e) {
  if (typeof e != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof e);
  return new Uint8Array(new TextEncoder().encode(e));
}
function xe(e) {
  return typeof e == "string" && (e = rt(e)), P(e), e;
}
function Tt(...e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    P(s), t += s.length;
  }
  const r = new Uint8Array(t);
  for (let n = 0, s = 0; n < e.length; n++) {
    const i = e[n];
    r.set(i, s), s += i.length;
  }
  return r;
}
class nt {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function st(e) {
  const t = (n) => e().update(xe(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function kt(e = 32) {
  if (x && typeof x.getRandomValues == "function")
    return x.getRandomValues(new Uint8Array(e));
  if (x && typeof x.randomBytes == "function")
    return x.randomBytes(e);
  throw new Error("crypto.getRandomValues must be defined");
}
const ve = [], Ee = [], $e = [], ot = /* @__PURE__ */ BigInt(0), $ = /* @__PURE__ */ BigInt(1), it = /* @__PURE__ */ BigInt(2), ct = /* @__PURE__ */ BigInt(7), at = /* @__PURE__ */ BigInt(256), ut = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = $, r = 1, n = 0; e < 24; e++) {
  [r, n] = [n, (2 * r + 3 * n) % 5], ve.push(2 * (5 * n + r)), Ee.push((e + 1) * (e + 2) / 2 % 64);
  let s = ot;
  for (let i = 0; i < 7; i++)
    t = (t << $ ^ (t >> ct) * ut) % at, t & it && (s ^= $ << ($ << /* @__PURE__ */ BigInt(i)) - $);
  $e.push(s);
}
const [lt, dt] = /* @__PURE__ */ Xe($e, !0), le = (e, t, r) => r > 32 ? Qe(e, t, r) : Ge(e, t, r), de = (e, t, r) => r > 32 ? Ye(e, t, r) : Ke(e, t, r);
function ft(e, t = 24) {
  const r = new Uint32Array(10);
  for (let n = 24 - t; n < 24; n++) {
    for (let o = 0; o < 10; o++)
      r[o] = e[o] ^ e[o + 10] ^ e[o + 20] ^ e[o + 30] ^ e[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const u = (o + 8) % 10, l = (o + 2) % 10, c = r[l], a = r[l + 1], m = le(c, a, 1) ^ r[u], f = de(c, a, 1) ^ r[u + 1];
      for (let d = 0; d < 50; d += 10)
        e[o + d] ^= m, e[o + d + 1] ^= f;
    }
    let s = e[2], i = e[3];
    for (let o = 0; o < 24; o++) {
      const u = Ee[o], l = le(s, i, u), c = de(s, i, u), a = ve[o];
      s = e[a], i = e[a + 1], e[a] = l, e[a + 1] = c;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let u = 0; u < 10; u++)
        r[u] = e[o + u];
      for (let u = 0; u < 10; u++)
        e[o + u] ^= ~r[(u + 2) % 10] & r[(u + 4) % 10];
    }
    e[0] ^= lt[n], e[1] ^= dt[n];
  }
  r.fill(0);
}
class N extends nt {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, r, n, s = !1, i = 24) {
    if (super(), this.blockLen = t, this.suffix = r, this.outputLen = n, this.enableXOF = s, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, j(n), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Ze(this.state);
  }
  keccak() {
    ae || ue(this.state32), ft(this.state32, this.rounds), ae || ue(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    ie(this);
    const { blockLen: r, state: n } = this;
    t = xe(t);
    const s = t.length;
    for (let i = 0; i < s; ) {
      const o = Math.min(r - this.pos, s - i);
      for (let u = 0; u < o; u++)
        n[this.pos++] ^= t[i++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: r, pos: n, blockLen: s } = this;
    t[n] ^= r, r & 128 && n === s - 1 && this.keccak(), t[s - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    ie(this, !1), P(t), this.finish();
    const r = this.state, { blockLen: n } = this;
    for (let s = 0, i = t.length; s < i; ) {
      this.posOut >= n && this.keccak();
      const o = Math.min(n - this.posOut, i - s);
      t.set(r.subarray(this.posOut, this.posOut + o), s), this.posOut += o, s += o;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return j(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (We(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: r, suffix: n, outputLen: s, rounds: i, enableXOF: o } = this;
    return t || (t = new N(r, n, s, o, i)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = i, t.suffix = n, t.outputLen = s, t.enableXOF = o, t.destroyed = this.destroyed, t;
  }
}
const ht = (e, t, r) => st(() => new N(t, e, r)), bt = /* @__PURE__ */ ht(1, 136, 256 / 8);
function pt(e, t) {
  const r = t || "hex", n = bt(L(e, { strict: !1 }) ? Be(e) : e);
  return r === "bytes" ? n : He(n);
}
const B = /* @__PURE__ */ new we(8192);
function Pe(e, t) {
  if (B.has(`${e}.${t}`))
    return B.get(`${e}.${t}`);
  const r = e.substring(2).toLowerCase(), n = pt(pe(r), "bytes"), s = r.split("");
  for (let o = 0; o < 40; o += 2)
    n[o >> 1] >> 4 >= 8 && s[o] && (s[o] = s[o].toUpperCase()), (n[o >> 1] & 15) >= 8 && s[o + 1] && (s[o + 1] = s[o + 1].toUpperCase());
  const i = `0x${s.join("")}`;
  return B.set(`${e}.${t}`, i), i;
}
function Ut(e, t) {
  if (!mt(e, { strict: !1 }))
    throw new Ve({ address: e });
  return Pe(e, t);
}
const gt = /^0x[a-fA-F0-9]{40}$/, z = /* @__PURE__ */ new we(8192);
function mt(e, t) {
  const { strict: r = !0 } = t ?? {}, n = `${e}.${r}`;
  if (z.has(n))
    return z.get(n);
  const s = gt.test(e) ? e.toLowerCase() === e ? !0 : r ? Pe(e) === e : !0 : !1;
  return z.set(n, s), s;
}
function Lt(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
const C = (e, t, r) => JSON.stringify(e, (n, s) => typeof s == "bigint" ? s.toString() : s, r), Nt = (e) => e, O = (e) => e;
class Ht extends h {
  constructor({ body: t, cause: r, details: n, headers: s, status: i, url: o }) {
    super("HTTP request failed.", {
      cause: r,
      details: n,
      metaMessages: [
        i && `Status: ${i}`,
        `URL: ${O(o)}`,
        t && `Request body: ${C(t)}`
      ].filter(Boolean),
      name: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = t, this.headers = s, this.status = i, this.url = o;
  }
}
class qt extends h {
  constructor({ body: t, cause: r, details: n, url: s }) {
    super("WebSocket request failed.", {
      cause: r,
      details: n,
      metaMessages: [
        `URL: ${O(s)}`,
        t && `Request body: ${C(t)}`
      ].filter(Boolean),
      name: "WebSocketRequestError"
    });
  }
}
class yt extends h {
  constructor({ body: t, error: r, url: n }) {
    super("RPC Request failed.", {
      cause: r,
      details: r.message,
      metaMessages: [`URL: ${O(n)}`, `Request body: ${C(t)}`],
      name: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = r.code, this.data = r.data;
  }
}
class Ft extends h {
  constructor({ url: t } = {}) {
    super("The socket has been closed.", {
      metaMessages: [t && `URL: ${O(t)}`].filter(Boolean),
      name: "SocketClosedError"
    });
  }
}
class Dt extends h {
  constructor({ body: t, url: r }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${O(r)}`, `Request body: ${C(t)}`],
      name: "TimeoutError"
    });
  }
}
const wt = -1;
class b extends h {
  constructor(t, { code: r, docsPath: n, metaMessages: s, name: i, shortMessage: o }) {
    super(o, {
      cause: t,
      docsPath: n,
      metaMessages: s || t?.metaMessages,
      name: i || "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = i || t.name, this.code = t instanceof yt ? t.code : r ?? wt;
  }
}
class E extends b {
  constructor(t, r) {
    super(t, r), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = r.data;
  }
}
class H extends b {
  constructor(t) {
    super(t, {
      code: H.code,
      name: "ParseRpcError",
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    });
  }
}
Object.defineProperty(H, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class q extends b {
  constructor(t) {
    super(t, {
      code: q.code,
      name: "InvalidRequestRpcError",
      shortMessage: "JSON is not a valid request object."
    });
  }
}
Object.defineProperty(q, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class F extends b {
  constructor(t, { method: r } = {}) {
    super(t, {
      code: F.code,
      name: "MethodNotFoundRpcError",
      shortMessage: `The method${r ? ` "${r}"` : ""} does not exist / is not available.`
    });
  }
}
Object.defineProperty(F, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class D extends b {
  constructor(t) {
    super(t, {
      code: D.code,
      name: "InvalidParamsRpcError",
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    });
  }
}
Object.defineProperty(D, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class V extends b {
  constructor(t) {
    super(t, {
      code: V.code,
      name: "InternalRpcError",
      shortMessage: "An internal error was received."
    });
  }
}
Object.defineProperty(V, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class _ extends b {
  constructor(t) {
    super(t, {
      code: _.code,
      name: "InvalidInputRpcError",
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    });
  }
}
Object.defineProperty(_, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class W extends b {
  constructor(t) {
    super(t, {
      code: W.code,
      name: "ResourceNotFoundRpcError",
      shortMessage: "Requested resource not found."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceNotFoundRpcError"
    });
  }
}
Object.defineProperty(W, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class J extends b {
  constructor(t) {
    super(t, {
      code: J.code,
      name: "ResourceUnavailableRpcError",
      shortMessage: "Requested resource not available."
    });
  }
}
Object.defineProperty(J, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class X extends b {
  constructor(t) {
    super(t, {
      code: X.code,
      name: "TransactionRejectedRpcError",
      shortMessage: "Transaction creation failed."
    });
  }
}
Object.defineProperty(X, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class G extends b {
  constructor(t, { method: r } = {}) {
    super(t, {
      code: G.code,
      name: "MethodNotSupportedRpcError",
      shortMessage: `Method${r ? ` "${r}"` : ""} is not supported.`
    });
  }
}
Object.defineProperty(G, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class K extends b {
  constructor(t) {
    super(t, {
      code: K.code,
      name: "LimitExceededRpcError",
      shortMessage: "Request exceeds defined limit."
    });
  }
}
Object.defineProperty(K, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class Q extends b {
  constructor(t) {
    super(t, {
      code: Q.code,
      name: "JsonRpcVersionUnsupportedError",
      shortMessage: "Version of JSON-RPC protocol is not supported."
    });
  }
}
Object.defineProperty(Q, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class Y extends E {
  constructor(t) {
    super(t, {
      code: Y.code,
      name: "UserRejectedRequestError",
      shortMessage: "User rejected the request."
    });
  }
}
Object.defineProperty(Y, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class Z extends E {
  constructor(t) {
    super(t, {
      code: Z.code,
      name: "UnauthorizedProviderError",
      shortMessage: "The requested method and/or account has not been authorized by the user."
    });
  }
}
Object.defineProperty(Z, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class ee extends E {
  constructor(t, { method: r } = {}) {
    super(t, {
      code: ee.code,
      name: "UnsupportedProviderMethodError",
      shortMessage: `The Provider does not support the requested method${r ? ` " ${r}"` : ""}.`
    });
  }
}
Object.defineProperty(ee, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class te extends E {
  constructor(t) {
    super(t, {
      code: te.code,
      name: "ProviderDisconnectedError",
      shortMessage: "The Provider is disconnected from all chains."
    });
  }
}
Object.defineProperty(te, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class re extends E {
  constructor(t) {
    super(t, {
      code: re.code,
      name: "ChainDisconnectedError",
      shortMessage: "The Provider is not connected to the requested chain."
    });
  }
}
Object.defineProperty(re, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
class ne extends E {
  constructor(t) {
    super(t, {
      code: ne.code,
      name: "SwitchChainError",
      shortMessage: "An error occurred when attempting to switch chain."
    });
  }
}
Object.defineProperty(ne, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4902
});
class Vt extends b {
  constructor(t) {
    super(t, {
      name: "UnknownRpcError",
      shortMessage: "An unknown RPC error occurred."
    });
  }
}
function xt() {
  let e = () => {
  }, t = () => {
  };
  return { promise: new Promise((n, s) => {
    e = n, t = s;
  }), resolve: e, reject: t };
}
const T = /* @__PURE__ */ new Map();
function _t({ fn: e, id: t, shouldSplitBatch: r, wait: n = 0, sort: s }) {
  const i = async () => {
    const a = l();
    o();
    const m = a.map(({ args: f }) => f);
    m.length !== 0 && e(m).then((f) => {
      s && Array.isArray(f) && f.sort(s);
      for (let d = 0; d < a.length; d++) {
        const { resolve: w } = a[d];
        w?.([f[d], f]);
      }
    }).catch((f) => {
      for (let d = 0; d < a.length; d++) {
        const { reject: w } = a[d];
        w?.(f);
      }
    });
  }, o = () => T.delete(t), u = () => l().map(({ args: a }) => a), l = () => T.get(t) || [], c = (a) => T.set(t, [...l(), a]);
  return {
    flush: o,
    async schedule(a) {
      const { promise: m, resolve: f, reject: d } = xt();
      return r?.([...u(), a]) && i(), l().length > 0 ? (c({ args: a, resolve: f, reject: d }), m) : (c({ args: a, resolve: f, reject: d }), setTimeout(i, n), m);
    }
  };
}
const vt = "2.16.5", Et = () => `@wagmi/core@${vt}`;
var Oe = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, M, Ae;
let g = class U extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return Et();
  }
  constructor(t, r = {}) {
    super(), M.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const n = r.cause instanceof U ? r.cause.details : r.cause?.message ? r.cause.message : r.details, s = r.cause instanceof U && r.cause.docsPath || r.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...s ? [
        `Docs: ${this.docsBaseUrl}${s}.html${r.docsSlug ? `#${r.docsSlug}` : ""}`
      ] : [],
      ...n ? [`Details: ${n}`] : [],
      `Version: ${this.version}`
    ].join(`
`), r.cause && (this.cause = r.cause), this.details = n, this.docsPath = s, this.metaMessages = r.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return Oe(this, M, "m", Ae).call(this, this, t);
  }
};
M = /* @__PURE__ */ new WeakSet(), Ae = function e(t, r) {
  return r?.(t) ? t : t.cause ? Oe(this, M, "m", e).call(this, t.cause, r) : t;
};
class Wt extends g {
  constructor() {
    super("Chain not configured."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotConfiguredError"
    });
  }
}
class Jt extends g {
  constructor() {
    super("Connector already connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAlreadyConnectedError"
    });
  }
}
class Xt extends g {
  constructor() {
    super("Connector not connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotConnectedError"
    });
  }
}
class Gt extends g {
  constructor() {
    super("Connector not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotFoundError"
    });
  }
}
class Kt extends g {
  constructor({ address: t, connector: r }) {
    super(`Account "${t}" not found for connector "${r.name}".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAccountNotFoundError"
    });
  }
}
class Qt extends g {
  constructor({ connectionChainId: t, connectorChainId: r }) {
    super(`The current chain of the connector (id: ${r}) does not match the connection's chain (id: ${t}).`, {
      metaMessages: [
        `Current Chain ID:  ${r}`,
        `Expected Chain ID: ${t}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorChainMismatchError"
    });
  }
}
class Yt extends g {
  constructor({ connector: t }) {
    super(`Connector "${t.name}" unavailable while reconnecting.`, {
      details: [
        "During the reconnection step, the only connector methods guaranteed to be available are: `id`, `name`, `type`, `uid`.",
        "All other methods are not guaranteed to be available until reconnection completes and connectors are fully restored.",
        "This error commonly occurs for connectors that asynchronously inject after reconnection has already started."
      ].join(" ")
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorUnavailableReconnectingError"
    });
  }
}
let k = !1;
async function $t(e, t = {}) {
  if (k)
    return [];
  k = !0, e.setState((c) => ({
    ...c,
    status: c.current ? "reconnecting" : "connecting"
  }));
  const r = [];
  if (t.connectors?.length)
    for (const c of t.connectors) {
      let a;
      typeof c == "function" ? a = e._internal.connectors.setup(c) : a = c, r.push(a);
    }
  else
    r.push(...e.connectors);
  let n;
  try {
    n = await e.storage?.getItem("recentConnectorId");
  } catch {
  }
  const s = {};
  for (const [, c] of e.state.connections)
    s[c.connector.id] = 1;
  n && (s[n] = 0);
  const i = Object.keys(s).length > 0 ? (
    // .toSorted()
    [...r].sort((c, a) => (s[c.id] ?? 10) - (s[a.id] ?? 10))
  ) : r;
  let o = !1;
  const u = [], l = [];
  for (const c of i) {
    const a = await c.getProvider().catch(() => {
    });
    if (!a || l.some((d) => d === a) || !await c.isAuthorized())
      continue;
    const f = await c.connect({ isReconnecting: !0 }).catch(() => null);
    f && (c.emitter.off("connect", e._internal.events.connect), c.emitter.on("change", e._internal.events.change), c.emitter.on("disconnect", e._internal.events.disconnect), e.setState((d) => {
      const w = new Map(o ? d.connections : /* @__PURE__ */ new Map()).set(c.uid, { accounts: f.accounts, chainId: f.chainId, connector: c });
      return {
        ...d,
        current: o ? d.current : c.uid,
        connections: w
      };
    }), u.push({
      accounts: f.accounts,
      chainId: f.chainId,
      connector: c
    }), l.push(a), o = !0);
  }
  return (e.state.status === "reconnecting" || e.state.status === "connecting") && (o ? e.setState((c) => ({ ...c, status: "connected" })) : e.setState((c) => ({
    ...c,
    connections: /* @__PURE__ */ new Map(),
    current: null,
    status: "disconnected"
  }))), k = !1, u;
}
class Zt extends g {
  constructor() {
    super("Provider not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderNotFoundError"
    });
  }
}
class er extends g {
  constructor({ connector: t }) {
    super(`"${t.name}" does not support programmatic chain switching.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SwitchChainNotSupportedError"
    });
  }
}
function Pt(e, t) {
  const { initialState: r, reconnectOnMount: n } = t;
  return r && !e._internal.store.persist.hasHydrated() && e.setState({
    ...r,
    chainId: e.chains.some((s) => s.id === r.chainId) ? r.chainId : e.chains[0].id,
    connections: n ? r.connections : /* @__PURE__ */ new Map(),
    status: n ? "reconnecting" : "disconnected"
  }), {
    async onMount() {
      e._internal.ssr && (await e._internal.store.persist.rehydrate(), e._internal.mipd && e._internal.connectors.setState((s) => {
        const i = /* @__PURE__ */ new Set();
        for (const l of s ?? [])
          if (l.rdns) {
            const c = Array.isArray(l.rdns) ? l.rdns : [l.rdns];
            for (const a of c)
              i.add(a);
          }
        const o = [], u = e._internal.mipd?.getProviders() ?? [];
        for (const l of u) {
          if (i.has(l.info.rdns))
            continue;
          const c = e._internal.connectors.providerDetailToConnector(l), a = e._internal.connectors.setup(c);
          o.push(a);
        }
        return [...s, ...o];
      })), n ? $t(e) : e.storage && e.setState((s) => ({
        ...s,
        connections: /* @__PURE__ */ new Map()
      }));
    }
  };
}
const Ot = Symbol(), tr = {
  install(e, t) {
    const { config: r, reconnectOnMount: n = !0 } = t;
    e.provide(Ot, r);
    const { onMount: s } = Pt(r, { ...t, reconnectOnMount: n });
    s();
  }
};
export {
  Q as $,
  Xt as A,
  h as B,
  Wt as C,
  Qt as D,
  Kt as E,
  Le as F,
  Rt as G,
  te as H,
  Ve as I,
  re as J,
  $t as K,
  we as L,
  Ot as M,
  Jt as N,
  Gt as O,
  Zt as P,
  er as Q,
  J as R,
  ne as S,
  Dt as T,
  Y as U,
  G as V,
  tr as W,
  Ht as X,
  Vt as Y,
  ee as Z,
  Z as _,
  Ue as a,
  K as a0,
  W as a1,
  V as a2,
  D as a3,
  F as a4,
  q as a5,
  H as a6,
  vt as a7,
  jt as a8,
  Re as a9,
  qe as aa,
  Se as ab,
  Mt as ac,
  y as ad,
  St as ae,
  Nt as af,
  g as ag,
  zt as ah,
  nt as ai,
  It as aj,
  ie as ak,
  xe as al,
  We as am,
  st as an,
  Bt as ao,
  O as ap,
  Ct as aq,
  P as ar,
  Tt as as,
  kt as at,
  me as b,
  Pe as c,
  R as d,
  Be as e,
  pe as f,
  Ut as g,
  ge as h,
  L as i,
  S as j,
  pt as k,
  _t as l,
  Ft as m,
  ye as n,
  qt as o,
  Lt as p,
  C as q,
  mt as r,
  se as s,
  He as t,
  De as u,
  _ as v,
  xt as w,
  X as x,
  yt as y,
  Yt as z
};
